module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [_c('prb-toolbar', {
    attrs: {
      "disable": !_vm.terms
    }
  }), _vm._v(" "), _c('prb-terms', {
    attrs: {
      "termsDialog": !_vm.terms
    }
  }), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "download__layout"
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "download__layout-card"
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "pa-0"
  }, [_c('div', {
    staticClass: "top__layout-title"
  }, [_vm._v("Download")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "blue-grey lighten-5 mb-2"
  }, [_c('p', [_vm._v(" - All the data calculated from the medicinal chemistry data available in canSAR (Tym et al., 2016; "), _c('a', {
    attrs: {
      "href": _vm.apiUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.apiUrl))]), _vm._v(") can be downloaded from the link below, including a list of all 355,305 human active compounds against all their human targets and their individual as well as global scores.")]), _vm._v(" "), _c('div', {
    staticClass: "text-sm-center"
  }, [_c('a', {
    staticClass: "link-download",
    attrs: {
      "href": "probeminer_datadump.zip",
      "target": "_blank",
      "download": ""
    }
  }, [_c('v-btn', {
    staticClass: "blue-grey white--text"
  }, [_vm._v("DOWNLOAD .TSV FILE")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-sm-center"
  }, [_c('a', {
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by/4.0/"
    }
  }, [_c('img', {
    staticStyle: {
      "border-width": "0"
    },
    attrs: {
      "alt": "Creative Commons License",
      "src": "https://i.creativecommons.org/l/by/4.0/88x31.png"
    }
  })]), _c('br'), _vm._v("This work is licensed under a "), _c('a', {
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by/4.0/"
    }
  }, [_vm._v("Creative Commons Attribution 4.0 International License")])])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "blue-grey lighten-5"
  }, [_c('p', [_vm._v(" - The Pipeline Pilot 9.5 protocol created by Gary Nugent to calculate the level 1 scaffolds (Langdon et al., 2011)")]), _vm._v(" "), _c('div', {
    staticClass: "text-sm-center"
  }, [_c('a', {
    staticClass: "link-download",
    attrs: {
      "href": "Generate_level1_Scaffolds_from_smiles.xml.zip",
      "target": "_blank",
      "download": ""
    }
  }, [_c('v-btn', {
    staticClass: "blue-grey white--text"
  }, [_vm._v("DOWNLOAD PIPELINE PILOT PROTOCOL")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-sm-center"
  }, [_c('a', {
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by/4.0/"
    }
  }, [_c('img', {
    staticStyle: {
      "border-width": "0"
    },
    attrs: {
      "alt": "Creative Commons License",
      "src": "https://i.creativecommons.org/l/by/4.0/88x31.png"
    }
  })]), _c('br'), _vm._v("This work is licensed under a "), _c('a', {
    attrs: {
      "rel": "license",
      "href": "http://creativecommons.org/licenses/by/4.0/"
    }
  }, [_vm._v("Creative Commons Attribution 4.0 International License")])])])], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('prb-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7d78012"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrbDownload.vue
// module id = 569
// module chunks = 1